export interface GetDetailListPayload {
  invoiceNumber: string;
  productNo?: string;
  posNext?: number;
}

export const filterPayload = (payload: GetDetailListPayload) => {
  return {
    invoiceNumber: payload.invoiceNumber,
    productNo: payload.productNo === '' ? undefined : payload.productNo,
    posNext: payload.posNext,
  };
};
